<app-non-production-banner />

<div class="centered">
  <app-siemens-logo />

  <h2 class="title">{{ appName }}</h2>

  <div role="alert" class="app-container message-container">
    <div class="icon-container">
      <app-icon-triangle-warning class="yellow" />
    </div>
    <div class="message">
      <h2 class="error-code"> 404 </h2>
      <p class="mt-2"> Not Found </p>
    </div>
  </div>

  <div class="button-containers">
    <button data-testid="error-home" class="my-reg-btn-2 mt-4 px-5" [routerLink]="['/']">
      <span class="icon-home me-1"></span>{{ label.homeButton() }}
    </button>
  </div>
</div>
